import React from "react";
import MicroModal from "react-micro-modal";
import Light from "../images/tainanVideo_light.svg";

const TainanVideo = () => {
    return (
        <section id="tainanVideo" className="tainanVideo">
            <h2
                className="title"
                data-aos="fade-in"
                data-aos-easing="linear"
                data-aos-duration="1000"
            >
                逗陣來台南
            </h2>
            <img className="light" src={Light} alt="video-light" />
            <MicroModal
                trigger={(open) => <div className="video" onClick={open}></div>}
                overrides={{
                    Overlay: {
                        style: { zIndex: 1500, backgroundColor: "rgba(0, 0, 0, 0.7)" }
                    },
                    Dialog: {
                        style: { padding: 0, maxWidth: 740, width: "90%", backgroundColor: "transparent" }
                    }
                }}
            >
                {(close) => (
                    <div className="video-container">
                        <iframe
                            width="100%"
                            height="auto"
                            src="https://www.youtube.com/embed/1_uFErqemK8?autoplay=1&mute=1"
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        >
                        </iframe>
                    </div>
                )}
            </MicroModal>
        </section>
    );
};

export default TainanVideo;
